import React from 'react';
import { Card } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const VocabularyUrlsCard = ({ vocabulary }) => (
  <Card.Description>
    <FormattedMessage id="items.count" values={{ count: vocabulary.urls.length }} />
  </Card.Description>
);

export default VocabularyUrlsCard;
